// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md class="mb-16">
    <v-row wrap>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'webhooks'"
        editRoute="webhookEdit"
        :headers="headers"
        name="Webhook"
        permissions="webhooks"
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ItemList from 'vue-common/components/ItemList.vue'
import {ENDPOINT} from '@/shared/constants'
import {getUserRolesText} from 'vue-common/components/utils'

export default {
  components: {
    ItemList
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'ID',
          value: 'id'
        },
        {
          text: 'Event',
          value: 'event'
        },
        {
          text: 'Target URL',
          value: 'targetUrl'
        }
      ]
    }
  },

  methods: {
    rolesToText: function (user, roles) {
      return getUserRolesText(user.roles, roles)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Webhooks.vue?82005164